<template>
  <BrandsFeed
    v-bind="{ getFirstPage, getNextPage }"
    :groq-params="groqParams"
  />
</template>

<script setup lang="ts">
import {
  brandsGroqFirst as getFirstPage,
  brandsGroqNext as getNextPage,
} from "~/groq/brands"

const props = withDefaults(
  defineProps<{
    groqParams?: Record<string, unknown>
  }>(),
  {
    groqParams: () => ({}),
  },
)

const { groqParams } = toRefs(props)

useHead({
  title: "Brands",
})
</script>
